import linkify from 'vue-linkify'
import Vue from 'vue'

Vue.directive('linkified', linkify);
